import { all } from 'redux-saga/effects';

import affiliateSaga from './affiliateSaga';
import campaignSaga from './campaignSaga';
import pageSaga from './pageSaga';
import mapSaga from './mapSaga';
import homeSaga from './homeSaga';
import puzzleRegSaga from './puzzleRegSaga';
import puzzleGeoSaga from './puzzleGeoSaga';
import puzzleEventsSaga from './puzzleEventsSaga';
import userSaga from './userSaga';
import cohortSaga from './cohortSaga';
import salesSaga from './salesSaga';
import activeUsersSaga from './activeUsersSaga';
import nftDepSaga from './nftDepSaga';
import byCountrySaga from './nftdep/byCountrySaga';
import byPmidSaga from './nftdep/byPmidSaga';
import byGameSaga from './nftdep/byGameSaga';
import byCampaignSaga from './nftdep/byCampaignSaga';
import nftDepTrendSaga from './nftdep/trendSaga';
import nftOwnTrendSaga from './nftdep/nftOwnTrendSaga';
import nftDepTxHistorySaga from './nftdep/txHistorySaga';
import nftHoldersSaga from './nftdep/nftHoldersSaga';
import stakingSaga from './nftdep/stakingSaga';
import walletBalanceSaga from './nftdep/balanceSaga';
import jtcbNftTrendSaga from './jtcb/nftTrendSaga';
import jtcbScolarrSaga from './jtcb/scholarSaga';
import avgRevenueSaga from './kpi/averageRevenueSaga';
import kpiSalesSaga from './kpi/kpiSalesSaga';
import cbScolarrSaga from './cookinburger/scholarSaga';
import lfGamePaidTrendSaga from './luckyfarmer/gamePaidTrendSaga';
import grGamePaidTrendSaga from './graffitiracer/gamePaidTrendSaga';
import cbGamePaidTrendSaga from './cookinburger/gamePaidTrendSaga';
import InGameSalesSaga from './salesIngame/InGameSalesSaga';
import InGameSalesTrendSaga from './salesIngame/InGameSalesTrendSaga';
import InGameSalesTxHistorySaga from './salesIngame/InGameSalesTxHistorySaga';
import nftSalesSaga from './salesNft/nftSalesSaga';
import pictreeHomeSaga from './pictree/pictreeHomeSaga';
import pictreeGameRegistrationSaga from './pictree/pictreeGameRegistrationSaga';
import pictreeSalesSaga from './pictree/pictreeSalesSaga';
import pictreePointSaga from './pictree/pictreePointSaga';
import pictreeGamePhotoShootSaga from './pictree/pictreeGamePhotoShootSaga';
import pictreeGameCheckInSaga from './pictree/pictreeGameCheckInSaga';
import pictreeUsersSaga from './pictree/pictreeUsersSaga';
import pictreeMissionSaga from './pictree/pictreeMissionSaga';
import pictreeRewardCoinSaga from './pictree/pictreeRewardCoinSaga';
import pictreeSeasonSaga from './pictree/pictreeSeasonSaga';
import pictreeTepcoSaga from './pictree/pictreeTepcoSaga';
import pictreeNttSaga from './pictree/pictreeNttSaga';
import pictreeNttFtSaga from './pictree/pictreeNttFtSaga';
import pictreeHokudenSaga from './pictree/pictreeHokudenSaga';
import pictreeRealTimeSaga from './pictree/pictreeRealTimeSaga';
import pictreeAdSaga from './pictree/pictreeAdSaga';
import pictreeReportSaga from './pictree/pictreeGameReportSaga';
import pictreeRealTimeDataSaga from './pictree/pictreeRealTimeDataSaga';
import pictreeItemSaga from './pictree/pictreeItemSaga';
import pictreeRankingSaga from './pictree/pictreeRankingSaga';
import pictreeAreaSaga from './pictree/pictreeAreaSaga';
import pictreeReviewSaga from './pictree/pictreeReviewSaga';
import pictreeRegularSeasonSaga from './pictree/pictreeRegularSeasonSaga';
import pictreeRegularSeasonEventSaga from './pictree/pictreeRegularSeasonEventSaga';
import pictreeRegularSeasonEventAreaSaga from './pictree/pictreeRegularSeasonEventAreaSaga';
import pictreeBudgetSaga from './pictree/pictreeBudgetSaga';
import pictreePlotSaga from './pictree/pictreePlotSaga';
import pictreeCommonSaga from './pictree/pictreeCommonSaga';
import a2eCampaignsSaga from './a2e/a2eCampaignsSaga';
import a2eSurveySaga from './a2e/a2eSurveySaga';

export default function* rootSaga() {
    yield all([
        affiliateSaga(), campaignSaga(), pageSaga(), mapSaga(), homeSaga(),
        puzzleRegSaga(), puzzleGeoSaga(), puzzleEventsSaga(), userSaga(),
        cohortSaga(), salesSaga(), activeUsersSaga(), nftDepSaga(), byCountrySaga(), byPmidSaga(), byGameSaga(), byCampaignSaga(),
        nftDepTrendSaga(), nftOwnTrendSaga(), nftDepTxHistorySaga(), nftHoldersSaga(), stakingSaga(), walletBalanceSaga(),
        jtcbNftTrendSaga(), jtcbScolarrSaga(), avgRevenueSaga(), kpiSalesSaga(), cbScolarrSaga(), lfGamePaidTrendSaga(), grGamePaidTrendSaga(),
        cbGamePaidTrendSaga(), InGameSalesSaga(), InGameSalesTrendSaga(), InGameSalesTxHistorySaga(),
        nftSalesSaga(),
        pictreeHomeSaga(), pictreeGameRegistrationSaga(), pictreeSalesSaga(), pictreePointSaga(),pictreeSeasonSaga(),
        pictreeGamePhotoShootSaga(), pictreeGameCheckInSaga(), pictreeUsersSaga(), pictreeMissionSaga(),pictreeRewardCoinSaga(),
        pictreeTepcoSaga(), pictreeNttSaga(), pictreeNttFtSaga(), pictreeHokudenSaga(),
        pictreeRealTimeSaga(), pictreeAdSaga(), pictreeReportSaga(), pictreeRealTimeDataSaga(), pictreeItemSaga(), pictreeRankingSaga(),
        pictreeAreaSaga(), pictreeReviewSaga(), pictreeRegularSeasonSaga(), pictreeRegularSeasonEventSaga(), pictreeRegularSeasonEventAreaSaga(),
        pictreeBudgetSaga(), pictreePlotSaga(),
        pictreeCommonSaga(),
        a2eCampaignsSaga(), a2eSurveySaga(),
    ]);
}
